/* =====================================================================
   CARRON CONFIGURATEUR v2 "pas a pas" (maquette handoff demi-mesure)
   Moteur generique : etapes = options produit (+ mot grave), auto-avance,
   recap sticky, prix decompose depuis les VRAIES variantes, dispo 35% +
   garde (bascule auto + notice), monogramme overlay, lightbox, mobile.
   Pilote le variant-picker natif masque (clickRadio) : prix / panier /
   URL restent 100% Shopify. Ne depend PAS de variant:change pour l'UI.
   ===================================================================== */
(function () {
  var root = document.querySelector('[data-cfg2]');
  if (!root) return;

  /* ---------------------------------------------------------- data */
  function J(sel) {
    var el = root.querySelector(sel);
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }
  var IMG = J('[data-cfg2-images]') || {};
  var VARIANTS = (J('[data-cfg2-variants]') || []).map(function (v) { v.opts = String(v.o).split('|'); return v; });
  var DIMS = J('[data-cfg2-dims]') || { anchor: 0, vals: {} };
  var I18N = J('[data-cfg2-i18n]') || {};
  var MONO = J('[data-cfg-mono-config]');
  var SAUCERS = J('[data-cfg2-saucers]');
  var COMPS = J('[data-cfg2-companions]');
  var FIT = J('[data-cfg2-overlay-fit]');
  var MULTI = J('[data-cfg2-multi]');
  var is_fr_lang = I18N.lang === 'fr';
  // avancement entre etapes : 'auto' (un clic enchaine, defaut historique) ou 'confirm'
  // (on peut comparer plusieurs valeurs, un bouton « Continuer » fait avancer)
  var STEP_MODE = root.getAttribute('data-cfg2-step-mode') === 'confirm' ? 'confirm' : 'auto';
  function autoAdvance(from) { if (STEP_MODE === 'auto') advance(from); }

  var PRICE = {};
  VARIANTS.forEach(function (v) { PRICE[v.o] = v.price; });

  var steps = [].slice.call(root.querySelectorAll('.cfg2-step'));
  var optSteps = steps.filter(function (s) { return s.getAttribute('data-cfg2-kind') === 'option'; });
  var wordStep = steps.filter(function (s) { return s.getAttribute('data-cfg2-kind') === 'word'; })[0] || null;
  var saucerStep = steps.filter(function (s) { return s.getAttribute('data-cfg2-kind') === 'saucer'; })[0] || null;
  var compStep = steps.filter(function (s) { return s.getAttribute('data-cfg2-kind') === 'companions'; })[0] || null;
  var STEP_COUNT = steps.length;
  var designStep = optSteps.filter(function (s) { return s.getAttribute('data-cfg2-style') === 'design'; })[0] || null;
  var designPos = designStep ? +designStep.getAttribute('data-cfg2-pos') : 0;
  var anchorPos = DIMS.anchor || 0;

  /* ---------------------------------------------------------- state */
  var stepNow = 1;
  var visited = {};
  visited[1] = true;
  var word = '';
  var saucer = null;          // {handle,title,id,price,matching} ou null (sans soucoupe)
  var lastSaucerSize = null;  // pour ne reconstruire les cartes qu'au changement de taille
  var pieceOn = {};           // mode multi : cle de piece -> cochee
  var rails = [];             // rangees defilables des familles (remplies plus bas)
  var comp = {};              // compagnons coches : handle -> true
  var lastCompKey = null;     // signature des cartes compagnons rendues
  var emptyExtra = {};        // etapes extra devenues sans objet (filtrage par `when`)
  var xTouched = {};          // etape extra ou le client a choisi explicitement
  var xVisSig = {};           // signature du jeu de choix visibles, pour detecter un changement

  /* -------------------------------------------------- combos / dispo */
  function stepByPos(pos) {
    return optSteps.filter(function (s) { return +s.getAttribute('data-cfg2-pos') === pos; })[0];
  }
  function cardsOf(pos) {
    var st = stepByPos(pos);
    return st ? [].slice.call(st.querySelectorAll('.cfg2-card')) : [];
  }
  function selCard(pos) {
    // mode multi : plusieurs cartes de l'ancre sont pressees (une par piece) ; la variante
    // native suit la piece PRINCIPALE
    if (MULTI && pos === anchorPos) return cardForPiece(mainPiece());
    return cardsOf(pos).filter(function (c) { return c.getAttribute('aria-pressed') === 'true'; })[0] || null;
  }
  /* ------------------------------------------------------- multi-pieces
     Un service de 1 a 3 pieces sur un seul produit. Chaque piece est une PLAGE D'INDEX
     de l'option d'ancrage (les 15 modeles couvrent 3 formats). Le MODELE est par piece,
     le DECOR / MOTIF / MOT sont communs : structure tiree de l'analyse des ventes
     (64 % des services passes melangent les modeles, 84 % n'ont qu'un seul decor).
     La piece principale porte la variante native (prix, panier, URL) ; les autres
     partent en lignes supplementaires a la soumission.                              */
  function pieceList() { return (MULTI && MULTI.pieces) || []; }
  function pieceAt(idx) {
    var ps = pieceList();
    for (var i = 0; i < ps.length; i++) {
      if (idx >= +ps[i].from && idx <= +ps[i].to) return ps[i];
    }
    return null;
  }
  function pieceLabel(p) {
    if (!p) return '';
    return (is_fr_lang && p.label && p.label.fr) ? p.label.fr : ((p.label && p.label.en) || p.key);
  }
  function selectedPieces() { return pieceList().filter(function (p) { return pieceOn[p.key]; }); }
  function mainPiece() { return selectedPieces()[0] || pieceList()[0] || null; }
  // carte de modele retenue pour une piece : celle qui est pressee dans sa plage, sinon
  // la premiere de la plage (pressee au passage, pour que l'etat DOM reste la verite)
  function cardForPiece(p) {
    if (!p) return null;
    var cards = cardsOf(anchorPos);
    var first = null;
    for (var i = +p.from; i <= +p.to && i < cards.length; i++) {
      if (!first) first = cards[i];
      if (cards[i].getAttribute('aria-pressed') === 'true') return cards[i];
    }
    if (first) first.setAttribute('aria-pressed', 'true');
    return first;
  }
  function pieceOfCard(card) {
    var cards = cardsOf(anchorPos);
    for (var i = 0; i < cards.length; i++) { if (cards[i] === card) return pieceAt(i); }
    return null;
  }
  function anchorIndexOfCard(card) {
    var cards = cardsOf(anchorPos);
    for (var i = 0; i < cards.length; i++) { if (cards[i] === card) return i; }
    return -1;
  }

  // une valeur existe-t-elle etant donne les choix des options PRECEDENTES ?
  function existsWithPrefix(pos, val, prefix) {
    return VARIANTS.some(function (v) {
      if (v.opts[pos - 1] !== val) return false;
      for (var i = 0; i < pos - 1; i++) { if (prefix[i] != null && v.opts[i] !== prefix[i]) return false; }
      return true;
    });
  }
  // valeur effective d'une carte (alias "main seule" pour les tailles ou la valeur principale n'existe pas)
  function effective(card, prefix) {
    var pos = +card.closest('.cfg2-step').getAttribute('data-cfg2-pos');
    var val = card.getAttribute('data-cfg2-val');
    var aliasVal = card.getAttribute('data-cfg2-alias-val');
    if (aliasVal && !existsWithPrefix(pos, val, prefix) && existsWithPrefix(pos, aliasVal, prefix)) {
      return { val: aliasVal, id: card.getAttribute('data-cfg2-alias-id') };
    }
    return { val: val, id: card.getAttribute('data-cfg2-val-id') };
  }
  function cardUsable(card, prefix) {
    var pos = +card.closest('.cfg2-step').getAttribute('data-cfg2-pos');
    var val = card.getAttribute('data-cfg2-val');
    var aliasVal = card.getAttribute('data-cfg2-alias-val');
    return existsWithPrefix(pos, val, prefix) || (aliasVal && existsWithPrefix(pos, aliasVal, prefix));
  }
  function currentCombo() {
    var combo = [];
    optSteps.forEach(function (st) {
      var pos = +st.getAttribute('data-cfg2-pos');
      var c = selCard(pos);
      combo[pos - 1] = c ? effective(c, combo).val : null;
    });
    return combo;
  }
  function variantByCombo(combo) {
    var key = combo.join('|');
    return VARIANTS.filter(function (v) { return v.o === key; })[0] || null;
  }
  // design "en attente" : une categorie (onglet) autre que "None" est ouverte mais
  // aucun motif concret de cette categorie n'est encore choisi -> choix obligatoire.
  function designPending() {
    if (!designStep) return false;
    var activeTab = designStep.querySelector('[data-cfg2-tab][aria-pressed="true"]');
    if (!activeTab) return false;
    var gi = activeTab.getAttribute('data-cfg2-tab');
    if (gi === '0') return false; // "None" (Sans) est un choix complet
    var sel = selCard(designPos);
    var selGi = sel ? (sel.getAttribute('data-cfg2-gi') || '0') : null;
    return selGi !== gi;
  }
  // combo resolu : cartes imposees par `overrides` ({pos: card}), premiere carte
  // utilisable partout ailleurs -> donne toujours une variante existante
  function comboWithOverride(overrides) {
    var combo = [];
    optSteps.forEach(function (st) {
      var pos = +st.getAttribute('data-cfg2-pos');
      if (overrides && overrides[pos]) { combo[pos - 1] = effective(overrides[pos], combo).val; return; }
      var cards = cardsOf(pos);
      for (var i = 0; i < cards.length; i++) {
        if (cardUsable(cards[i], combo)) { combo[pos - 1] = effective(cards[i], combo).val; return; }
      }
      combo[pos - 1] = null;
    });
    return combo;
  }
  function baseCombo() { return comboWithOverride(null); }

  /* -------------------------------------------------- prix decompose en cascade
     Le recap partait de « la premiere valeur de chaque option » et mesurait chaque
     choix isolement. Deux defauts :
       - sur le mug, la premiere anse est l'anse simple, facturee : choisir « Sans
         anse » valait -11 €, la ligne negative etait filtree et le recap affichait
         92 + 10 pour un total de 91 ;
       - quand une valeur n'existe pas partout (les anses du bol changent avec la
         taille, le mug XL impose une anse), la combinaison mesuree n'existait pas
         et la ligne disparaissait purement et simplement.
     On part donc de la piece la MOINS CHERE, puis on applique les choix du client
     un par un, dans l'ordre des etapes. Chaque ligne vaut l'ecart avec l'etape
     precedente : la somme des lignes retombe sur le total par construction, quelle
     que soit la grille. */
  function priceAtStep(combo, uptoPos) {
    var best = null;
    VARIANTS.forEach(function (v) {
      if (v.av === false) return;
      for (var i = 0; i < uptoPos; i++) {
        if (combo[i] != null && v.opts[i] !== combo[i]) return;
      }
      if (!best || v.price < best.price) best = v;
    });
    return best ? best.price : null;
  }

  /* ---------------------------------------------------------- money
     Tout l'affichage des prix est deduit du GABARIT rendu par Liquid
     ({{ variant.price | money }}), jamais d'un symbole code en dur : le
     storefront sert le marche du visiteur (€92,00 en France, ₩152,000 en
     Coree ou le format est "₩{{amount_no_decimals}}"). On lit donc dans le
     gabarit le prefixe, le suffixe, le separateur decimal, celui des
     milliers et le nombre de decimales, puis on reformate a l'identique.  */
  var moneyTpl = '';
  var tplEl = root.querySelector('[data-cfg2-cta-price]') || root.querySelector('[data-cfg2-mp-price]');
  if (tplEl) moneyTpl = tplEl.textContent.trim();

  var MONEY = (function () {
    if (!moneyTpl) return null;
    var m = moneyTpl.match(/\d[\d.,   ]*/);
    if (!m) return null;
    var num = m[0].replace(/[\s  ]+$/, '');
    // decimales = dernier separateur suivi d'EXACTEMENT deux chiffres finaux :
    // "92,00" en a, "152,000" (milliers coreens) n'en a pas.
    var dm = num.match(/([.,])(\d{2})$/);
    var dec = dm ? dm[1] : '';
    var intPart = dec ? num.slice(0, -3) : num;
    // separateur de milliers : celui deja visible, sinon l'autre de la paire
    var gm = intPart.match(/[.,   ](?=\d)/);
    var group = gm ? gm[0] : (dec === ',' ? '.' : dec === '.' ? ',' : '');
    return {
      prefix: moneyTpl.slice(0, m.index),
      // suffixe mesure sur `num` et non sur la capture : celle-ci a pu avaler
      // l'espace qui separe le montant du symbole (« 92,00 € »)
      suffix: moneyTpl.slice(m.index + num.length),
      dec: dec,
      group: group,
      digits: dec ? 2 : 0
    };
  })();

  // dropDecimals : les deltas s'affichent a l'unite (« + €140 »), comme la maquette
  function fmtMoney(cents, dropDecimals) {
    if (!MONEY) return String(Math.round(cents / 100));
    var digits = dropDecimals ? 0 : MONEY.digits;
    var fixed = Math.abs(cents / 100).toFixed(digits);
    var parts = fixed.split('.');
    var whole = parts[0];
    if (MONEY.group) whole = whole.replace(/\B(?=(\d{3})+(?!\d))/g, MONEY.group);
    return (cents < 0 ? '-' : '') + MONEY.prefix + whole + (parts[1] ? MONEY.dec + parts[1] : '') + MONEY.suffix;
  }
  // Delta de prix : « + €140 », « − €11 ». Meme devise et meme format que le total.
  function fmtDelta(cents) {
    return (cents < 0 ? '− ' : '+ ') + fmtMoney(Math.round(Math.abs(cents) / 100) * 100, true);
  }

  /* -------------------------------------------------------- picker natif */
  function clickRadio(pos, valId) {
    if (pos == null || valId == null || valId === '') return false;
    var r = document.querySelector('variant-picker input[type="radio"][data-option-position="' + pos + '"][value="' + valId + '"]');
    if (r) { if (!r.checked) r.click(); return true; }
    return false;
  }
  function syncNativePicker() {
    var prefix = [];
    optSteps.forEach(function (st) {
      var pos = +st.getAttribute('data-cfg2-pos');
      var c = selCard(pos);
      if (!c) return;
      var eff = effective(c, prefix);
      prefix[pos - 1] = eff.val;
      clickRadio(pos, eff.id);
    });
  }

  /* ---------------------------------------------------------- loader */
  var imgWrap = root.querySelector('.cfg2-recap__imgwrap');
  var loaderEl = null, loaderTimer = null;
  if (imgWrap) {
    loaderEl = document.createElement('span');
    loaderEl.className = 'cfg2-loader';
    loaderEl.setAttribute('hidden', '');
    loaderEl.setAttribute('aria-hidden', 'true');
    imgWrap.appendChild(loaderEl);
  }
  function hideLoader() { if (loaderEl) { loaderEl.setAttribute('hidden', ''); } clearTimeout(loaderTimer); }
  function showLoader() { if (!loaderEl) return; loaderEl.removeAttribute('hidden'); clearTimeout(loaderTimer); loaderTimer = setTimeout(hideLoader, 1400); }

  /* ---------------------------------------------------------- images */
  function imgAt(url, w) { return url ? url.replace(/width=\d+/, 'width=' + w) : url; }
  // image d'un combo : exacte, sinon variante la plus proche qui matche l'option variee
  function imgFor(combo, pos) {
    var exact = IMG[combo.join('|')];
    if (exact) return exact;
    var best = null, bestScore = -1;
    VARIANTS.forEach(function (v) {
      if (pos && v.opts[pos - 1] !== combo[pos - 1]) return;
      var u = IMG[v.o];
      if (!u) return;
      var score = 0;
      for (var i = 0; i < combo.length; i++) { if (v.opts[i] === combo[i]) score++; }
      if (score > bestScore) { bestScore = score; best = u; }
    });
    return best;
  }

  /* ------------------------------------------------------- monogramme */
  var monoBox = root.querySelector('[data-cfg-mono]');
  var monoValue = root.querySelector('[data-cfg-mono-value]');
  var monoLetters = [].slice.call(root.querySelectorAll('[data-cfg-mono-letter]'));
  var monoOverlay = root.querySelector('[data-cfg-mono-overlay]');
  function monoActive(combo) { return !!(MONO && combo.indexOf(MONO.value) >= 0); }
  function currentLetter() { return monoValue ? (monoValue.value || '').toUpperCase() : ''; }
  function updateMono(combo) {
    if (!MONO || !monoBox) return;
    var on = monoActive(combo);
    if (on) { monoBox.removeAttribute('hidden'); if (monoValue && monoValue.value) monoValue.disabled = false; }
    else { monoBox.setAttribute('hidden', ''); if (monoValue) monoValue.disabled = true; }
    var letter = currentLetter();
    var showOverlay = on && letter && MONO.letters[letter];
    [monoOverlay, lbOverlay].forEach(function (ov) {
      if (!ov) return;
      if (showOverlay) { ov.src = MONO.letters[letter]; ov.removeAttribute('hidden'); }
      else { ov.setAttribute('hidden', ''); }
    });
  }
  monoLetters.forEach(function (b) {
    b.addEventListener('click', function () {
      if (monoValue) { monoValue.value = b.getAttribute('data-cfg-mono-letter'); monoValue.disabled = false; }
      monoLetters.forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
      render();
      // la lettre choisie, on avance a l'etape suivante (le choix Monogramme lui-meme n'avance pas)
      if (designStep) autoAdvance(+designStep.getAttribute('data-cfg2-step'));
    });
  });

  /* ------------------------------------------------- etapes extra (cfg2) */
  // etapes declaratives sans variante (metafield custom.cfg2_extra_steps) :
  // cartes de choix + sous-panneau couleurs / texte, properties rattachees au
  // form natif via form=. Aucun effet si le produit n'a pas d'etape extra.
  var extras = {};
  var extraSteps = steps.filter(function (s) { return s.getAttribute('data-cfg2-kind') === 'extra'; });

  /* --- choix conditionnels (data-cfg2-when) ---------------------------------
     Un choix d'etape extra peut ne valoir que pour certaines valeurs d'une option
     de variante : {"pos": 2, "values": ["Embossed", "Embosse"]}. On cible l'option
     par POSITION et on compare des valeurs normalisees, parce que le storefront FR
     renvoie les valeurs d'option traduites. Sans l'attribut, un choix est toujours
     visible : les produits existants ne changent pas d'un pixel.                */
  function norml(s) {
    s = String(s == null ? '' : s).toLowerCase();
    // retire les accents quand le moteur JS le permet (tous les navigateurs cibles)
    return s.normalize ? s.normalize('NFD').replace(/[\u0300-\u036f]/g, '') : s;
  }
  function whenOf(card) {
    var raw = card.getAttribute('data-cfg2-when');
    if (!raw) return null;
    try { return JSON.parse(raw); } catch (e) { return null; }
  }
  // le choix est-il pertinent pour la combinaison d'options courante ?
  function choiceOn(card, combo) {
    var w = whenOf(card);
    if (!w) return true;
    var pos = +w.pos;
    if (!pos) return true;
    var cur = norml(combo[pos - 1]);
    var vals = w.values || [];
    for (var i = 0; i < vals.length; i++) { if (norml(vals[i]) === cur) return true; }
    return false;
  }
  // applique le filtrage a une etape : masque les cartes hors condition et
  // rapatrie la selection sur le premier choix visible si besoin
  function filterExtra(st, combo) {
    var cards = [].slice.call(st.querySelectorAll('.cfg2-card[data-cfg2-extra-val]'));
    var conditional = false, visible = [], sel = null;
    cards.forEach(function (c) {
      if (c.getAttribute('data-cfg2-when')) conditional = true;
      var on = choiceOn(c, combo);
      if (on) { c.removeAttribute('hidden'); visible.push(c); }
      else { c.setAttribute('hidden', ''); c.setAttribute('aria-pressed', 'false'); }
      if (c.getAttribute('aria-pressed') === 'true') sel = c;
    });
    // jeu de choix change (autre decor) : le choix precedent ne vaut plus comme choix du client
    var stepSig = +st.getAttribute('data-cfg2-step');
    var sig = visible.map(function (c) { return c.getAttribute('data-cfg2-extra-val'); }).join('|');
    if (xVisSig[stepSig] !== sig) { xVisSig[stepSig] = sig; xTouched[stepSig] = false; }
    if (!conditional) return { conditional: false, visible: visible, only: null };
    if (!sel && visible.length) {
      visible[0].setAttribute('aria-pressed', 'true');
      sel = visible[0];
    }
    // etape sans veritable choix : un seul choix visible, et c'est un "none"
    var only = (visible.length === 1 && visible[0].hasAttribute('data-cfg2-extra-none')) ? visible[0] : null;
    return { conditional: true, visible: visible, only: only };
  }

  /* --- groupes d'ancrage --------------------------------------------------------
     Un produit peut reunir plusieurs formats (les 15 modeles d'assiette). Un meme
     motif n'a alors pas le meme calque selon le format, et les vignettes d'une autre
     option doivent suivre le modele choisi. On regroupe les valeurs de l'ancre par
     PLAGES D'INDEX, jamais par libelle : les valeurs sont traduites sur le FR.     */
  function anchorIndex() {
    if (!anchorPos) return -1;
    var cards = cardsOf(anchorPos);
    // mode multi : une carte est pressee PAR PIECE, la reference est la piece principale
    if (MULTI) return anchorIndexOfCard(cardForPiece(mainPiece()));
    for (var i = 0; i < cards.length; i++) {
      if (cards[i].getAttribute('aria-pressed') === 'true') return i;
    }
    return -1;
  }
  function groupKey(st, forIdx) {
    var raw = st && st.getAttribute('data-cfg2-groups');
    if (!raw) return '';
    var g; try { g = JSON.parse(raw); } catch (e) { return ''; }
    var idx = (forIdx == null) ? anchorIndex() : forIdx;
    if (idx < 0) return '';
    var r = g.ranges || [];
    for (var j = 0; j < r.length; j++) { if (idx <= +r[j].to) return r[j].key; }
    return r.length ? r[r.length - 1].key : '';
  }
  // une valeur d'attribut peut etre une URL, ou un objet {groupe: URL} a resoudre
  function pickForGroup(raw, key) {
    if (!raw) return '';
    if (raw.charAt(0) !== '{') return raw;
    var m; try { m = JSON.parse(raw); } catch (e) { return ''; }
    return (key && m[key]) || m[Object.keys(m)[0]] || '';
  }

  // echelle a appliquer au calque : emprise de la piece courante / emprise d'origine
  function overlayScaleFor(card, gkey) {
    if (!FIT || !FIT.frac) return 1;
    if (!(+FIT.anchorPos || anchorPos)) return 1;
    var idx = anchorIndex();
    if (idx < 0) return 1;
    var cur = FIT.frac[idx];
    var authored = parseFloat(pickForGroup(card.getAttribute('data-overlay-fit-map'), gkey) || card.getAttribute('data-overlay-fit') || '');
    if (!cur || !authored) return 1;
    return cur / authored;
  }

  function extraSelCard(st) {
    return st.querySelector('.cfg2-card[data-cfg2-extra-val][aria-pressed="true"]');
  }
  // lit l'etat d'une etape extra depuis le DOM, montre le bon sous-panneau et
  // synchronise les inputs hidden (actives des qu'ils portent une valeur)
  function syncExtra(st) {
    var prop = st.getAttribute('data-cfg2-extra-prop');
    var card = extraSelCard(st);
    var val = card ? card.getAttribute('data-cfg2-extra-val') : '';
    // choix "none" (ex Sans bijou) : affiche comme un choix mais n'envoie AUCUNE property
    var isNone = !!(card && card.hasAttribute('data-cfg2-extra-none'));
    var state = { choice: isNone ? '' : val, label: val, none: isNone, color: '', colorLabel: '', colorProp: '', text: '', textProp: '', hasText: false, textOverlay: false, textUpper: false, textNotice: '', textOverflow: 0, textColor: '', textGradient: '', overlay: '', overlayScale: 1 };
    [].forEach.call(st.querySelectorAll('[data-cfg2-extra-panel]'), function (p) {
      if (card && p.getAttribute('data-cfg2-extra-panel') === val) p.removeAttribute('hidden');
      else p.setAttribute('hidden', '');
    });
    var gkey = groupKey(st);
    // vignettes des cartes : celles qui portent une map suivent le format choisi
    [].forEach.call(st.querySelectorAll('.cfg2-card[data-thumb-map]'), function (c) {
      var u = pickForGroup(c.getAttribute('data-thumb-map'), gkey);
      var im = c.querySelector('[data-cfg2-extra-thumb]');
      if (!u || !im) return;
      u = u + (u.indexOf('?') >= 0 ? '&' : '?') + 'width=240';
      if (im.getAttribute('src') !== u) im.src = u;
    });
    if (card) {
      var lab = card.querySelector('[data-cfg2-extra-label]');
      if (lab && lab.textContent) state.label = lab.textContent.trim() || val;
      state.overlay = pickForGroup(card.getAttribute('data-overlay-map'), gkey) || card.getAttribute('data-overlay-src') || '';
      // mise a l'echelle du calque sur la piece choisie (cf. cfg2_overlay_fit) : sans ca un
      // calque partage entre formats tombe hors de l'assiette sur les petites pieces
      state.overlayScale = overlayScaleFor(card, gkey);
      var panel = st.querySelector('[data-cfg2-extra-panel="' + val + '"]');
      if (panel) {
        var colWrap = panel.querySelector('[data-cfg2-extra-colorprop]');
        if (colWrap) {
          state.colorProp = colWrap.getAttribute('data-cfg2-extra-colorprop');
          var swatches = [].slice.call(colWrap.querySelectorAll('.cfg2-extra__color'));
          var cb = swatches.filter(function (x) { return x.getAttribute('aria-pressed') === 'true'; })[0] || swatches[0] || null;
          if (cb) {
            swatches.forEach(function (x) { x.setAttribute('aria-pressed', x === cb ? 'true' : 'false'); });
            state.color = cb.getAttribute('data-cfg2-extra-color') || '';
            state.colorLabel = cb.getAttribute('data-cfg2-extra-color-label') || state.color;
            var cbOv = pickForGroup(cb.getAttribute('data-overlay-map'), gkey) || cb.getAttribute('data-overlay-src');
            if (cbOv) state.overlay = cbOv;
            var dot = cb.querySelector('.cfg2-extra__dot');
            if (dot) state.textColor = getComputedStyle(dot).backgroundColor;
            state.textGradient = cb.getAttribute('data-cfg2-extra-color-gradient') || '';
          }
        }
        var txtWrap = panel.querySelector('[data-cfg2-extra-textprop]');
        if (txtWrap) {
          state.hasText = true;
          state.textProp = txtWrap.getAttribute('data-cfg2-extra-textprop');
          state.textOverlay = txtWrap.hasAttribute('data-cfg2-extra-text-overlay');
          state.textBox = txtWrap.getAttribute('data-cfg2-extra-text-box') || '';
          state.textUpper = txtWrap.hasAttribute('data-cfg2-extra-text-upper');
          state.textNotice = txtWrap.getAttribute('data-cfg2-extra-text-notice') || '';
          // debordement TOLERE (% de la largeur de box) : sur un monogramme de 2 lettres
          // on veut la plus grande taille possible, quitte a mordre tres legerement hors
          // de la box. 0 (defaut) = comportement d'origine, strictement dans la box.
          state.textOverflow = parseFloat(txtWrap.getAttribute('data-cfg2-extra-text-overflow') || '0') || 0;
          var ti = txtWrap.querySelector('[data-cfg2-extra-text]');
          if (ti) {
            state.text = ti.value.trim();
            // text.uppercase (monogramme) : la saisie est affichee en MAJ par le CSS,
            // on normalise ici la VALEUR pour que la property, l'apercu peint et le
            // resume partent en majuscules (l'atelier recoit "AB", jamais "ab").
            if (state.textUpper) state.text = state.text.toUpperCase();
          }
        }
      }
    }
    [].forEach.call(st.querySelectorAll('[data-cfg2-extra-input]'), function (inp) {
      var p = inp.getAttribute('data-cfg2-extra-input');
      var v = '';
      if (p === prop) v = state.choice;
      else if (p === state.colorProp) v = state.color;
      else if (p === state.textProp) v = state.text;
      inp.value = v;
      inp.disabled = v === '';
    });
    extras[prop] = state;
    return state;
  }
  // resume d'une etape extra : Choix · Couleur · « texte »
  function extraSummary(st) {
    var s = extras[st.getAttribute('data-cfg2-extra-prop')];
    if (!s) return '';
    if (s.none) {
      // choix "none" sans perso : libelle seul (ex "Sans bijou" du grigri)
      if (!s.hasText) return s.label;
      // etape a perso unique portee par un choix "none" (ex monogramme, hide_choices) :
      // on resume la perso elle-meme, pas le libelle technique du choix
      if (!s.text) return '';
      return '« ' + s.text + ' »' + (s.color ? ' · ' + s.colorLabel : '');
    }
    if (!s.choice) return '';
    var t = s.label;
    if (s.color) t += ' · ' + s.colorLabel;
    if (s.hasText && s.text) t += ' · « ' + s.text + ' »';
    return t;
  }
  function hideLbExtras() {
    if (!lb) return;
    [].forEach.call(lb.querySelectorAll('[data-cfg2-extra-overlay]'), function (ov) { ov.setAttribute('hidden', ''); });
    [].forEach.call(lb.querySelectorAll('[data-cfg2-extra-textov]'), function (ov) { ov.setAttribute('hidden', ''); });
  }
  // overlay TEXTE (ex prenom peint) : SVG plein cadre, scale avec l'apercu (recap + lightbox)
  var SVG_NS = 'http://www.w3.org/2000/svg';
  /* --- or peint : VRAI degrade, pas un aplat -------------------------------
     Une couleur declaree avec `"gradient": "gold"` dans cfg2_extra_steps est
     peinte avec le degrade or de la maison (celui des eyebrows/titres, cf.
     carron-config.css) au lieu d'un aplat : un aplat brun ne ressemble pas a
     de l'or a l'oeil. Memes arrets que le CSS, angle equivalent a 95deg.
     Sans le flag, le texte reste peint de la couleur de la pastille.        */
  var GOLD_STOPS = [['0%', '#8a6a2f'], ['26%', '#C9A86A'], ['50%', '#E7D29A'], ['72%', '#B68C45'], ['100%', '#8a6a2f']];
  var gradSeq = 0;
  function goldGradientId(svg) {
    var id = svg.getAttribute('data-cfg2-grad-id');
    if (id) return id;
    gradSeq += 1;
    id = 'cfg2-gold-' + gradSeq;
    var defs = document.createElementNS(SVG_NS, 'defs');
    var g = document.createElementNS(SVG_NS, 'linearGradient');
    g.setAttribute('id', id);
    g.setAttribute('x1', '0%'); g.setAttribute('y1', '0%');
    g.setAttribute('x2', '100%'); g.setAttribute('y2', '9%');
    GOLD_STOPS.forEach(function (st) {
      var s = document.createElementNS(SVG_NS, 'stop');
      s.setAttribute('offset', st[0]);
      s.setAttribute('stop-color', st[1]);
      g.appendChild(s);
    });
    defs.appendChild(g);
    svg.insertBefore(defs, svg.firstChild);
    svg.setAttribute('data-cfg2-grad-id', id);
    return id;
  }
  function textOverlaySlot(wrap, prop) {
    if (!wrap) return null;
    var el = wrap.querySelector('[data-cfg2-extra-textov="' + prop + '"]');
    if (!el) {
      el = document.createElementNS(SVG_NS, 'svg');
      el.setAttribute('viewBox', '0 0 100 100');
      el.setAttribute('class', 'cfg2-extra__textov');
      el.setAttribute('data-cfg2-extra-textov', prop);
      el.setAttribute('aria-hidden', 'true');
      el.setAttribute('hidden', '');
      var tx = document.createElementNS(SVG_NS, 'text');
      tx.setAttribute('x', '50');
      tx.setAttribute('y', '30');
      tx.setAttribute('text-anchor', 'middle');
      el.appendChild(tx);
      wrap.appendChild(el);
    }
    return el;
  }
  // lignes recap + overlays plein cadre (recap et lightbox, mecanique monogramme)
  // + validation : choix a texte mais champ vide -> notice + commande bloquee
  function updateExtras() {
    var pending = null;   // {step, msg} de la premiere etape qui bloque, sinon null
    var xCombo = currentCombo();
    extraSteps.forEach(function (st) {
      var prop = st.getAttribute('data-cfg2-extra-prop');
      // choix conditionnels : on filtre AVANT de lire l'etat, et on relit toujours le
      // DOM quand l'etape est conditionnelle (le filtrage a pu deplacer la selection)
      var f = filterExtra(st, xCombo);
      emptyExtra[+st.getAttribute('data-cfg2-step')] = !!f.only;
      var s = f.conditional ? syncExtra(st) : (extras[prop] || syncExtra(st));
      var line = root.querySelector('[data-cfg2-recap-val="x-' + prop + '"]');
      if (line) line.textContent = extraSummary(st) || '-';
      var slots = [].slice.call(root.querySelectorAll('[data-cfg2-extra-overlay="' + prop + '"]'));
      if (lb) slots = slots.concat([].slice.call(lb.querySelectorAll('[data-cfg2-extra-overlay="' + prop + '"]')));
      slots.forEach(function (ov) {
        if (s.overlay) {
          if (ov.getAttribute('src') !== s.overlay) ov.src = s.overlay;
          // echelle autour du centre du cadre : le calque et la piece y sont tous deux centres
          ov.style.transform = (s.overlayScale && Math.abs(s.overlayScale - 1) > 0.005) ? 'scale(' + s.overlayScale.toFixed(4) + ')' : '';
          ov.removeAttribute('hidden');
        }
        else { ov.setAttribute('hidden', ''); }
      });
      // texte peint en direct sur l'apercu (choix avec text.overlay) : reprise du custom
      // APO CARRON (template demi-mesure) = fonte CarronPersonalization + fit-to-box.
      // Box par defaut = zone gri-gri du custom (left 26% top 23% w 48% h 28%),
      // surchargeable par text.box "l,t,w,h" dans le JSON.
      var tWraps = [imgWrap];
      if (lb) tWraps.push(lb.querySelector('.cfg2-lightbox__imgwrap'));
      var tSlots = [];
      tWraps.forEach(function (w) { var sl = textOverlaySlot(w, prop); if (sl) tSlots.push(sl); });
      if (s.textOverlay && s.text) {
        var bx = (s.textBox || '26,23,48,28').split(',');
        var bl = +bx[0], bt = +bx[1], bw = +bx[2], bh = +bx[3];
        var availW = bw - 4 + bw * (s.textOverflow || 0) / 100;
        var cx = bl + bw / 2, cy = bt + bh / 2;
        var fs = bh - 4;
        // mesure reelle sur le premier slot rendu (recap), estimation sinon
        var meas = 0;
        for (var mi = 0; mi < tSlots.length && !meas; mi++) {
          var mtx = tSlots[mi].querySelector('text');
          mtx.textContent = s.text;
          mtx.setAttribute('font-size', String(fs));
          tSlots[mi].removeAttribute('hidden');
          try { meas = mtx.getComputedTextLength(); } catch (e) { meas = 0; }
        }
        if (!meas) meas = s.text.length * fs * 0.5;
        var tfs = meas > availW ? Math.max(3, fs * availW / meas) : fs;
        tSlots.forEach(function (sl) {
          var tx = sl.querySelector('text');
          tx.textContent = s.text;
          tx.setAttribute('x', String(cx));
          tx.setAttribute('y', String(cy + tfs * 0.34));
          tx.setAttribute('font-size', String(tfs));
          tx.setAttribute('fill', s.textGradient === 'gold' ? 'url(#' + goldGradientId(sl) + ')' : (s.textColor || '#1d1d1b'));
          sl.removeAttribute('hidden');
        });
      } else {
        tSlots.forEach(function (sl) { sl.setAttribute('hidden', ''); });
      }
      var miss = s.hasText && !s.text;
      // choix EXPLICITE requis (declare par l'etape) : sans ca, choisir « Monogramme »
      // partait avec la lettre A par defaut, sur une piece faite main non retournable
      var stepN2 = +st.getAttribute('data-cfg2-step');
      var visN = st.querySelectorAll('.cfg2-card[data-cfg2-extra-val]:not([hidden])').length;
      var needPick = st.hasAttribute('data-cfg2-require-choice') && visN > 1 && !xTouched[stepN2];
      showNotice(st, miss ? (s.textNotice || I18N.writeText || 'Write your word.')
                          : (needPick ? (st.getAttribute('data-cfg2-require-msg') || I18N.pickDesign || I18N.pickChoice || 'Choose an option.') : null));
      if ((miss || needPick) && !pending) {
        // on retient QUELLE etape bloque, pour pouvoir le dire a cote du bouton
        pending = { step: stepN2, msg: (st.querySelector('[data-cfg2-notice]') || {}).textContent || '' };
      }
    });
    return pending;
  }
  extraSteps.forEach(function (st) {
    var stepN = +st.getAttribute('data-cfg2-step');
    var xCards = [].slice.call(st.querySelectorAll('.cfg2-card[data-cfg2-extra-val]'));
    xCards.forEach(function (card) {
      card.addEventListener('click', function () {
        var already = card.getAttribute('aria-pressed') === 'true';
        xTouched[stepN] = true;
        xCards.forEach(function (c) { c.setAttribute('aria-pressed', c === card ? 'true' : 'false'); });
        syncExtra(st);
        render();
        // choix avec sous-panneau (couleurs / texte) : on reste sur l'etape
        if (!already && !card.hasAttribute('data-cfg2-extra-haspanel')) autoAdvance(stepN);
      });
    });
    [].forEach.call(st.querySelectorAll('.cfg2-extra__color'), function (b) {
      b.addEventListener('click', function () {
        var wrap = b.closest('[data-cfg2-extra-colorprop]');
        if (wrap) [].forEach.call(wrap.querySelectorAll('.cfg2-extra__color'), function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
        syncExtra(st);
        render();
        autoAdvance(stepN);
      });
    });
    [].forEach.call(st.querySelectorAll('[data-cfg2-extra-text]'), function (ti) {
      ti.addEventListener('input', function () { syncExtra(st); render(); });
    });
    [].forEach.call(st.querySelectorAll('[data-cfg2-extra-done]'), function (b) {
      b.addEventListener('click', function () {
        var s = syncExtra(st);
        render();
        if (s.hasText && !s.text) return; // mot manquant : notice affichee, on reste
        advance(stepN);
      });
    });
    syncExtra(st); // boot : 1er choix + 1re couleur, inputs hidden actives
  });

  /* --------------------------------------------------------- lightbox */
  var lb = null, lbImg = null, lbOverlay = null, lbCaption = null, lbWrap = null;
  function buildLightbox() {
    if (lb) return lb;
    lb = document.createElement('div');
    lb.className = 'cfg2-lightbox';
    lb.innerHTML = '<figure class="cfg2-lightbox__figure"><button type="button" class="cfg2-lightbox__close" aria-label="Close">×</button><div class="cfg2-lightbox__imgwrap"><img alt=""><img class="cfg2-recap__mono" alt="" hidden></div><figcaption class="cfg2-lightbox__caption"></figcaption></figure>';
    document.body.appendChild(lb);
    var imgs = lb.querySelectorAll('img');
    lbImg = imgs[0]; lbOverlay = imgs[1];
    lbCaption = lb.querySelector('.cfg2-lightbox__caption');
    // slots overlay des etapes extra (miroir de ceux du recap imgwrap)
    lbWrap = lb.querySelector('.cfg2-lightbox__imgwrap');
    extraSteps.forEach(function (st) {
      var ov = document.createElement('img');
      ov.className = 'cfg2-recap__mono';
      ov.alt = '';
      ov.setAttribute('data-cfg2-extra-overlay', st.getAttribute('data-cfg2-extra-prop'));
      ov.setAttribute('hidden', '');
      lbWrap.appendChild(ov);
    });
    lb.addEventListener('click', function (e) { if (!e.target.closest('.cfg2-lightbox__figure') || e.target.closest('.cfg2-lightbox__close')) closeLightbox(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeLightbox(); });
    return lb;
  }
  function openLightbox() {
    buildLightbox();
    var combo = currentCombo();
    var u = imgFor(combo);
    if (u) lbImg.src = imgAt(u, 1400);
    var letter = currentLetter();
    if (monoActive(combo) && letter && MONO.letters[letter]) { lbOverlay.src = MONO.letters[letter]; lbOverlay.removeAttribute('hidden'); }
    else { lbOverlay.setAttribute('hidden', ''); }
    var bits = [];
    // en mode multi, la legende enumere les pieces du service comme la ligne du recap :
    // l'image montre trois assiettes, le texte ne peut pas n'en nommer qu'une
    if (MULTI && selectedPieces().length > 1) {
      bits = selectedPieces().map(function (p) {
        var cd = cardForPiece(p);
        return pieceLabel(p) + ' ' + familyOf(cd ? cd.getAttribute('data-cfg2-val') : '');
      });
    } else if (anchorPos) bits.push(labelOf(anchorPos, combo[anchorPos - 1]));
    if (designPos) bits.push(labelOf(designPos, combo[designPos - 1]));
    if (!bits.length) bits = combo.filter(Boolean);
    var cap = bits.join(' · ');
    if (word) cap += ' · ' + (I18N.engraved || 'engraved') + ' « ' + word + ' »';
    lbCaption.textContent = cap + ' - ' + (I18N.unique || 'each piece is unique.');
    if (extraSteps.length) updateExtras(); // rafraichit les overlays extra de la lightbox
    // un service se zoome empile, comme il se pose sur la table
    stackInto(lbWrap, lbImg, stackSel, 1400);
    lb.classList.add('is-open');
  }
  function closeLightbox() { if (lb) lb.classList.remove('is-open'); }
  // ouvre la lightbox sur une image quelconque (ex : agrandir une soucoupe)
  function openLightboxImg(url, caption) {
    buildLightbox();
    if (url) lbImg.src = imgAt(url, 1400);
    lbOverlay.setAttribute('hidden', '');
    hideLbExtras();
    stackInto(lbWrap, lbImg, [], 1400);   // zoom d'une piece isolee : pas d'empilement
    lbCaption.textContent = caption || '';
    lb.classList.add('is-open');
  }
  [].forEach.call(root.querySelectorAll('[data-cfg2-zoom-open]'), function (b) {
    b.addEventListener('click', openLightbox);
  });

  /* ------------------------------------------------------ etapes / UI */
  /* Recalage du scroll sur l'etape active.
     Quand une etape se replie, la page raccourcit : sans recalage on se retrouve
     n'importe ou, souvent au-dessus ou en dessous de l'etape ouverte. On aligne donc
     toujours le haut de l'etape active juste sous les barres collantes (en-tete du
     theme si elle est sticky, + barre d'apercu mobile), sur mobile comme sur desktop. */
  function stickyOffset() {
    var off = 0;
    var cs = getComputedStyle(document.documentElement);
    if ((cs.getPropertyValue('--sticky-header-enabled') || '').trim() === '1') {
      off += parseFloat(cs.getPropertyValue('--header-height')) || 0;
    }
    var mp = root.querySelector('[data-cfg2-mobilepreview]');
    if (mp && getComputedStyle(mp).position === 'sticky' && mp.offsetHeight) off += mp.offsetHeight;
    return off + 14;
  }
  function scrollToStep(n) {
    var st = steps[n - 1];
    if (!st) return;
    // apres le repli de l'etape precedente : on mesure une fois la mise en page faite
    window.requestAnimationFrame(function () {
      var top = st.getBoundingClientRect().top + window.pageYOffset - stickyOffset();
      if (top < 0) top = 0;
      if (Math.abs(top - window.pageYOffset) < 8) return; // deja au bon endroit
      try { window.scrollTo({ top: top, behavior: 'smooth' }); }
      catch (e) { window.scrollTo(0, top); }
    });
  }
  function goTo(n, scroll) {
    stepNow = n;
    if (n >= 1) visited[n] = true;
    render();
    if (n >= 1) scrollToStep(n);
  }
  // etapes extra devenues sans objet (un seul choix visible, et c'est un "none") :
  // ex le motif quand le decor est Simple. On les traverse au lieu de s'y arreter.
  function nextStepAfter(from) {
    var n = from + 1;
    while (n <= STEP_COUNT && emptyExtra[n]) { visited[n] = true; n++; }
    return n <= STEP_COUNT ? n : 0;
  }
  function advance(from) {
    var to = from < STEP_COUNT ? nextStepAfter(from) : 0;
    window.setTimeout(function () { goTo(to); }, 320);
  }
  function showNotice(step, msg) {
    var n = step.querySelector('[data-cfg2-notice]');
    if (!n) return;
    if (msg) { n.textContent = msg; n.removeAttribute('hidden'); }
    else { n.setAttribute('hidden', ''); }
  }
  function clearNotices() { steps.forEach(function (s) { showNotice(s, null); }); }

  // apres un choix : re-resoudre les etapes suivantes (garde) + notices
  function resolveFrom(changedPos) {
    var prefix = [];
    optSteps.forEach(function (st) {
      var pos = +st.getAttribute('data-cfg2-pos');
      var cur = selCard(pos);
      if (cur && cardUsable(cur, prefix)) {
        prefix[pos - 1] = effective(cur, prefix).val;
        return;
      }
      // valeur courante impossible : basculer vers la carte "soeur" (meme main), sinon la 1re utilisable
      var cards = cardsOf(pos);
      var curVal = cur ? cur.getAttribute('data-cfg2-val') : '';
      var curHand = (curVal.match(/\(([^)]+)\)/) || [])[1] || '';
      var next = null;
      if (curHand) {
        next = cards.filter(function (c) {
          var h = (c.getAttribute('data-cfg2-val').match(/\(([^)]+)\)/) || [])[1] || '';
          return c !== cur && h.toLowerCase() === curHand.toLowerCase() && cardUsable(c, prefix);
        })[0] || null;
      }
      if (!next) next = cards.filter(function (c) { return cardUsable(c, prefix); })[0] || null;
      if (next) {
        cards.forEach(function (c) { c.setAttribute('aria-pressed', c === next ? 'true' : 'false'); });
        var eff = effective(next, prefix);
        prefix[pos - 1] = eff.val;
        if (cur && changedPos !== pos) {
          var ctx = anchorPos ? prefix[anchorPos - 1] : '';
          var msg = (I18N.notice || '{from} is not available in {ctx} - switched to {to}.')
            .replace('{from}', labelOf(pos, curVal)).replace('{ctx}', labelOf(anchorPos, ctx)).replace('{to}', labelOf(pos, eff.val));
          showNotice(stepByPos(pos), msg);
        }
      }
    });
  }

  /* ------------------------------------------------------- rendu global */
  // libelle AFFICHE d'une valeur d'option : le Liquid pose data-cfg2-label quand la valeur
  // stockee n'est pas dans la langue de la page (Sans / Aucun / Monogramme sur le site EN,
  // No handle sur le FR). Les combos, le picker natif et le panier gardent la valeur brute.
  function labelOf(pos, val) {
    if (!val) return val || '';
    var cards = cardsOf(pos);
    for (var i = 0; i < cards.length; i++) {
      if (cards[i].getAttribute('data-cfg2-val') === val) return cards[i].getAttribute('data-cfg2-label') || val;
    }
    return val;
  }
  function summaryFor(pos, combo) {
    var v = combo[pos - 1] || '';
    var lab = labelOf(pos, v);
    if (pos === anchorPos && DIMS.vals[v] && DIMS.vals[v].d) return lab + ' · ' + DIMS.vals[v].d;
    if (pos === designPos && monoActive(combo) && currentLetter()) return lab + ' · ' + currentLetter();
    return lab;
  }
  /* ------------------------------------------------------ soucoupe */
  function escHtml(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function saucerSizeVal() {
    var combo = currentCombo();
    var pos = (SAUCERS && SAUCERS.sizePos) || anchorPos;
    return pos ? (combo[pos - 1] || '') : '';
  }
  function mkSaucer(it, size) { var s = it.sizes[size]; return { handle: it.handle, title: it.title, id: s.id, price: s.price, matching: !!it.matching }; }
  function saucerItemsFor(size) {
    return (SAUCERS && SAUCERS.items ? SAUCERS.items : []).filter(function (it) { return it.sizes && it.sizes[size]; });
  }
  function markSaucer(grid) {
    if (!grid) return;
    [].forEach.call(grid.querySelectorAll('.cfg2-card'), function (c) {
      var on = (saucer && c.getAttribute('data-cfg2-saucer-h') === saucer.handle) || (!saucer && c.hasAttribute('data-cfg2-saucer-none'));
      c.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  }
  // soucoupe assortie selon le design courant (table designMatch -> defaut)
  function saucerMatchHandle() {
    var combo = currentCombo();
    var dsn = designPos ? (combo[designPos - 1] || '') : '';
    return (SAUCERS.designMatch && SAUCERS.designMatch[dsn]) || SAUCERS.defaultMatch;
  }
  // "sans soucoupe" : photo Paris grisee (en CSS) + gros rond barre par-dessus
  var NO_SAUCER_SVG = '<svg class="cfg2-nosaucer__cross" viewBox="0 0 100 100" fill="none" aria-hidden="true">'
    + '<circle cx="50" cy="50" r="34" stroke="#7c776b" stroke-width="3.5"/>'
    + '<line x1="26" y1="26" x2="74" y2="74" stroke="#7c776b" stroke-width="3.5"/></svg>';
  function buildSaucerCards() {
    if (!SAUCERS || !saucerStep) return;
    var grid = saucerStep.querySelector('[data-cfg2-saucer-grid]');
    if (!grid) return;
    var size = saucerSizeVal();
    var matchH = saucerMatchHandle();
    // filtrer par taille + placer l'assortie (selon design) en premier
    var avail = saucerItemsFor(size).slice().sort(function (a, b) {
      return (a.handle === matchH ? 0 : 1) - (b.handle === matchH ? 0 : 1);
    });
    // soucoupe choisie encore valide dans cette taille ? sinon reset a "sans"
    if (saucer) {
      var still = avail.filter(function (it) { return it.handle === saucer.handle; })[0];
      saucer = still ? mkSaucer(still, size) : null;
    }
    var noneImg = SAUCERS.noneImg ? imgAt(SAUCERS.noneImg, 240) : '';
    var html = '<button type="button" class="cfg2-card cfg2-card--pick cfg2-card--saucer-none" data-cfg2-saucer-none aria-pressed="' + (saucer ? 'false' : 'true') + '">'
      + '<span class="cfg2-card__img cfg2-card__img--pad cfg2-nosaucer">'
      + (noneImg ? '<img class="cfg2-nosaucer__img" src="' + noneImg + '" alt="" loading="lazy">' : '')
      + NO_SAUCER_SVG + '</span>'
      + '<span class="cfg2-card__body"><span class="cfg2-card__kind">' + escHtml(SAUCERS.i18n.none) + '</span></span></button>';
    avail.forEach(function (it) {
      var s = it.sizes[size];
      var isMatch = it.handle === matchH;
      var sub = isMatch ? '<span class="cfg2-card__match">' + escHtml(SAUCERS.i18n.withLabel) + '</span>' : '';
      html += '<button type="button" class="cfg2-card cfg2-card--pick' + (isMatch ? ' cfg2-card--saucer-match' : '') + '" data-cfg2-saucer-h="' + escHtml(it.handle) + '" aria-pressed="' + (saucer && saucer.handle === it.handle ? 'true' : 'false') + '">'
        + '<span class="cfg2-card__img cfg2-card__img--pad"><img src="' + imgAt(s.img, 240) + '" alt="' + escHtml(it.title) + '" loading="lazy">'
        + '<span class="cfg2-card__zoom" data-cfg2-saucer-zoom data-zoom-img="' + imgAt(s.img, 900) + '" data-zoom-cap="' + escHtml(it.title) + '" role="button" aria-label="' + escHtml(SAUCERS.i18n.enlarge || 'Enlarge') + '">⤢</span></span>'
        + '<span class="cfg2-card__body">' + sub
        + '<span class="cfg2-card__kind">' + escHtml(it.title)
        + (it.handle ? '<span class="cfg2-card__extlink" data-cfg2-saucer-link data-link-url="' + escHtml(it.url || ('/products/' + it.handle)) + '" role="link" aria-label="' + escHtml(it.title) + '" title="' + escHtml(it.title) + '">↗</span>' : '')
        + '</span>'
        + '<span class="cfg2-card__delta">' + fmtDelta(s.price) + '</span></span></button>';
    });
    grid.innerHTML = html;
    [].forEach.call(grid.querySelectorAll('[data-cfg2-saucer-zoom]'), function (z) {
      z.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation();
        openLightboxImg(z.getAttribute('data-zoom-img'), z.getAttribute('data-zoom-cap'));
      });
    });
    [].forEach.call(grid.querySelectorAll('[data-cfg2-saucer-link]'), function (a) {
      a.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation();
        window.open(a.getAttribute('data-link-url'), '_blank', 'noopener');
      });
    });
    var noneBtn = grid.querySelector('[data-cfg2-saucer-none]');
    if (noneBtn) noneBtn.addEventListener('click', function () { saucer = null; markSaucer(grid); render(); });
    [].forEach.call(grid.querySelectorAll('[data-cfg2-saucer-h]'), function (b) {
      b.addEventListener('click', function () {
        var it = avail.filter(function (x) { return x.handle === b.getAttribute('data-cfg2-saucer-h'); })[0];
        if (it) { saucer = mkSaucer(it, size); markSaucer(grid); render(); }
      });
    });
  }

  /* ------------------------------------------------------ compagnons
     « La meme piece dans les autres formats » : un service de table, c'est le meme
     modele et le meme decor en presentation, plate et dessert. Les variantes des
     autres produits viennent du metafield pre-calcule cfg2_companions (all_products
     ignore les brouillons). Correspondance par NOM de modele exact, sans repli : un
     modele qui n'existe pas dans l'autre format ne propose rien.                  */
  var compModelPos = COMPS ? (+COMPS.modelPos || anchorPos || 1) : 0;
  var compDecorPos = COMPS ? (+COMPS.decorPos || 0) : 0;

  function decorIndex() {
    if (!compDecorPos) return 0;
    var cards = cardsOf(compDecorPos);
    for (var i = 0; i < cards.length; i++) {
      if (cards[i].getAttribute('aria-pressed') === 'true') return i;
    }
    return 0;
  }
  // compagnons proposables pour le modele courant, avec leur variante et leur prix.
  // Deux modes :
  //  - "internal" (un seul produit reunit les formats) : les compagnons sont d'AUTRES
  //    VALEURS D'ANCRAGE du meme produit, de la meme famille de modele. Rien n'est
  //    pre-calcule : ids, prix et images viennent des variantes deja serialisees, donc
  //    aucune donnee a regenerer quand un prix change.
  //  - sinon : produits distincts decrits dans le metafield (formes pre-calculees).
  // La famille se lit avant la parenthese du libelle ("Paris (dinner)" -> "Paris"), ce
  // qui reste vrai en francais puisque seule la parenthese est traduite.
  function familyOf(v) { return String(v || '').split('(')[0].trim(); }
  function formatOf(v) {
    var m = String(v || '').match(/\(([^)]+)\)/);
    if (!m) return '';
    var t = m[1].trim();
    return t.charAt(0).toUpperCase() + t.slice(1);
  }
  function compAvail(combo) {
    if (!COMPS) return [];
    if (COMPS.mode === 'internal') {
      var pos = +COMPS.anchorPos || anchorPos;
      if (!pos) return [];
      var cur = combo[pos - 1] || '';
      var base = familyOf(cur);
      if (!base) return [];
      var out = [];
      cardsOf(pos).forEach(function (card, ci) {
        var val = card.getAttribute('data-cfg2-val');
        if (!val || val === cur || familyOf(val) !== base) return;
        var c2 = combo.slice(); c2[pos - 1] = val;
        var v = variantByCombo(c2);
        if (!v || v.av === false) return;
        out.push({ handle: val, label: formatOf(val) || val, model: base, ai: ci,
                   dim: (DIMS.vals[val] || {}).d || '', img: IMG[c2.join('|')] || '',
                   id: String(v.id), price: v.price });
      });
      return out;
    }
    if (!COMPS.items) return [];
    var modelName = combo[compModelPos - 1] || '';
    var di = decorIndex();
    var out2 = [];
    COMPS.items.forEach(function (it) {
      var m = it.models && it.models[modelName];
      if (!m || !m.v || !m.v[di] || !m.v[di].id) return;
      out2.push({
        handle: it.handle,
        label: (is_fr_lang && it.label && it.label.fr) ? it.label.fr : ((it.label && it.label.en) || it.handle),
        model: modelName, dim: m.dim || '', img: m.img || '',
        id: m.v[di].id, price: m.v[di].p
      });
    });
    return out2;
  }
  function compOn(combo) {
    return compAvail(combo).filter(function (c) { return comp[c.handle]; });
  }
  // mode multi : les pieces secondaires du service, chacune avec SON modele et le decor commun
  function multiPieces(combo) {
    var out = [];
    var main = mainPiece();
    selectedPieces().forEach(function (p) {
      if (main && p.key === main.key) return;
      var card = cardForPiece(p);
      if (!card) return;
      var val = card.getAttribute('data-cfg2-val');
      var ai = anchorIndexOfCard(card);
      var c2 = combo.slice(); c2[anchorPos - 1] = val;
      var v = variantByCombo(c2);
      if (!v) return;
      out.push({ handle: p.key, label: pieceLabel(p), model: familyOf(val), ai: ai,
                 dim: (DIMS.vals[val] || {}).d || '', img: IMG[c2.join('|')] || '',
                 id: String(v.id), price: v.price, av: v.av !== false });
    });
    return out;
  }
  // source unique des lignes supplementaires : rendu ET soumission lisent celle-ci
  function extraPieces(combo) {
    return MULTI ? multiPieces(combo || currentCombo()) : compOn(combo || currentCombo());
  }
  function buildCompCards(combo) {
    if (!compStep) return;
    var grid = compStep.querySelector('[data-cfg2-comp-grid]');
    if (!grid) return;
    var list = compAvail(combo);
    var key = list.map(function (c) { return c.handle + ':' + c.id; }).join(',');
    if (key === lastCompKey) { markComp(grid); return; }
    lastCompKey = key;
    if (!list.length) {
      grid.innerHTML = '<p class="cfg2-help-line">' + escHtml(I18N.compNone || '') + '</p>';
      return;
    }
    var html = '';
    list.forEach(function (c) {
      html += '<button type="button" class="cfg2-card cfg2-card--pick" data-cfg2-comp="' + escHtml(c.handle) + '" aria-pressed="' + (comp[c.handle] ? 'true' : 'false') + '">'
        + '<span class="cfg2-card__img cfg2-card__img--pad"><img src="' + escHtml(imgAt(c.img, 240)) + '" alt="" loading="lazy"></span>'
        + '<span class="cfg2-card__body">'
        + '<span class="cfg2-card__kind">' + escHtml(c.label) + '</span>'
        + (c.dim ? '<span class="cfg2-card__hand">' + escHtml(c.dim) + '</span>' : '')
        + '<span class="cfg2-card__delta">' + fmtDelta(c.price) + '</span>'
        + '</span></button>';
    });
    grid.innerHTML = html;
    [].forEach.call(grid.querySelectorAll('[data-cfg2-comp]'), function (b) {
      b.addEventListener('click', function () {
        var h = b.getAttribute('data-cfg2-comp');
        comp[h] = !comp[h];
        markComp(grid);
        render();
      });
    });
  }
  function markComp(grid) {
    if (!grid) return;
    [].forEach.call(grid.querySelectorAll('[data-cfg2-comp]'), function (b) {
      b.setAttribute('aria-pressed', comp[b.getAttribute('data-cfg2-comp')] ? 'true' : 'false');
    });
  }

  /* ------------------------------------------------- empilement a l'echelle
     Les fonds APO sont dessines A L'ECHELLE REELLE dans un cadre commun : superposer
     les pieces d'un service revient donc a empiler leurs images, sans aucun calcul de
     proportion. La plus grande au fond, la plus petite au-dessus, chacune avec son
     propre calque de decor mis a son echelle.                                        */
  // calque de decor a appliquer a une piece donnee (par son index d'ancrage)
  function overlayForAnchorIndex(ai) {
    var st = extraSteps.filter(function (x) { return x.querySelector('[data-cfg2-extra-val][aria-pressed="true"]'); })[0];
    if (!st) return null;
    var card = extraSelCard(st);
    if (!card || card.hasAttribute('data-cfg2-extra-none')) return null;
    var gk = groupKey(st, ai);
    var url = pickForGroup(card.getAttribute('data-overlay-map'), gk) || card.getAttribute('data-overlay-src') || '';
    if (!url) return null;
    var scale = 1;
    if (FIT && FIT.frac) {
      var authored = parseFloat(pickForGroup(card.getAttribute('data-overlay-fit-map'), gk) || card.getAttribute('data-overlay-fit') || '');
      if (authored && FIT.frac[ai]) scale = FIT.frac[ai] / authored;
    }
    return { url: url, scale: scale };
  }
  function mkLayer(src, z, scale) {
    var im = document.createElement('img');
    im.className = 'cfg2-recap__mono';
    im.setAttribute('data-cfg2-stacklayer', '');
    im.alt = '';
    im.src = src;
    im.style.zIndex = String(z);
    if (scale && Math.abs(scale - 1) > 0.005) im.style.transform = 'scale(' + scale.toFixed(4) + ')';
    return im;
  }
  /* Empilement des pieces d'un service. La MEME mecanique sert l'apercu et la
     lightbox : seules changent la largeur d'image demandee et le conteneur. Avant,
     seul l'apercu empilait, donc zoomer un service de trois assiettes n'en montrait
     qu'une (signale par Charles le 2026-07-28). */
  var stackSel = [];
  function stackInto(wrap, mainImg, sel, w) {
    if (!wrap) return;
    [].forEach.call(wrap.querySelectorAll('[data-cfg2-stacklayer]'), function (e) { e.remove(); });
    var mainOvs = [].slice.call(wrap.querySelectorAll('.cfg2-recap__mono:not([data-cfg2-stacklayer])'));
    if (!sel || !sel.length || !FIT || !FIT.frac) {
      if (mainImg) mainImg.style.zIndex = '';
      mainOvs.forEach(function (o) { o.style.zIndex = ''; });
      return;
    }
    var fr = FIT.frac;
    var entries = [{ main: true, frac: fr[anchorIndex()] || 1 }];
    sel.forEach(function (c) { entries.push({ main: false, ai: c.ai, img: c.img, frac: fr[c.ai] || 1 }); });
    // la plus grande piece en dessous : l'ordre d'empilement est celui de la table
    entries.sort(function (a, b) { return b.frac - a.frac; });
    entries.forEach(function (e, i) {
      var z = (i + 1) * 10;
      if (e.main) {
        if (mainImg) mainImg.style.zIndex = String(z);
        mainOvs.forEach(function (o) { o.style.zIndex = String(z + 1); });
        return;
      }
      if (!e.img) return;
      wrap.appendChild(mkLayer(imgAt(e.img, w), z, 1));
      var ov = overlayForAnchorIndex(e.ai);
      if (ov) wrap.appendChild(mkLayer(ov.url, z + 1, ov.scale));
    });
  }
  function renderStack(sel) {
    stackSel = sel || [];
    stackInto(imgWrap, root.querySelector('[data-cfg2-recap-img]'), stackSel, 720);
  }

  /* En mode multi, le decor / le motif / le mot sont COMMUNS a toutes les pieces du
     service (structure validee sur les ventes). On le dit explicitement des qu'il y a
     plus d'une piece, sur chaque etape concernee, plutot que de le laisser deviner. */
  function updateCommonNotes() {
    if (!MULTI) return;
    var n = selectedPieces().length;
    var txt = n > 1 ? (I18N.commonAll || '').replace('{n}', String(n)) : '';
    steps.forEach(function (st) {
      var kind = st.getAttribute('data-cfg2-kind');
      if (kind === 'pieces') return;
      // l'etape du modele est la seule qui se demultiplie : elle n'est pas concernee
      if (kind === 'option' && +st.getAttribute('data-cfg2-pos') === anchorPos) return;
      var body = st.querySelector('[data-cfg2-body]');
      if (!body) return;
      var el = body.querySelector('[data-cfg2-common-note]');
      if (!el) {
        el = document.createElement('p');
        el.className = 'cfg2-common-note';
        el.setAttribute('data-cfg2-common-note', '');
        body.insertBefore(el, body.firstChild);
      }
      if (txt) { el.textContent = txt; el.removeAttribute('hidden'); }
      else el.setAttribute('hidden', '');
    });
  }

  function render() {
    var combo = currentCombo();
    // etapes extra sans objet (un seul choix visible, et c'est un « sans ») : on le sait
    // avant de poser les classes, sinon l'etat de grisage aurait une image de retard
    extraSteps.forEach(function (st) {
      emptyExtra[+st.getAttribute('data-cfg2-step')] = !!filterExtra(st, combo).only;
      // etat relu tout de suite : le filtrage a pu deplacer la selection, et le resume
      // pose juste apres lirait sinon l'ancien choix (« Charles » au lieu de « Sans »)
      syncExtra(st);
    });
    var variant = variantByCombo(combo);
    var total = variant ? variant.price : null;
    var base = PRICE[baseCombo().join('|')];

    // soucoupe : reconstruire les cartes au changement de taille OU de design (l'assortie suit le design)
    if (SAUCERS && saucerStep) {
      var szNow = saucerSizeVal();
      var dsNow = designPos ? (combo[designPos - 1] || '') : '';
      var keyNow = szNow + '||' + dsNow;
      if (keyNow !== lastSaucerSize) { lastSaucerSize = keyNow; buildSaucerCards(); }
    }
    var grandTotal = total;
    if (total != null && saucer) grandTotal = total + saucer.price;

    // compagnons : cartes reconstruites quand le modele ou le decor change
    var compSel = [];
    if (MULTI) {
      // une famille de modeles n'est montree que si sa piece est cochee
      [].forEach.call(root.querySelectorAll('.cfg2-family'), function (fam) {
        var c0 = fam.querySelector('.cfg2-card');
        var p = c0 ? pieceOfCard(c0) : null;
        if (!p) return;
        if (pieceOn[p.key]) fam.removeAttribute('hidden');
        else fam.setAttribute('hidden', '');
      });
      compSel = multiPieces(combo);
      if (total != null) compSel.forEach(function (c) { grandTotal += c.price; });
    } else if (COMPS && compStep) {
      buildCompCards(combo);
      compSel = compOn(combo);
      if (total != null) compSel.forEach(function (c) { grandTotal += c.price; });
    }

    // etats des etapes
    steps.forEach(function (st, i) {
      var n = i + 1;
      var active = stepNow === n;
      var done = !active && visited[n];
      st.classList.toggle('is-active', active);
      st.classList.toggle('is-done', !!done);
      var num = st.querySelector('[data-cfg2-num]');
      if (num) num.textContent = done ? '✓' : String(n);
      // etape sans rien a choisir (ex le motif quand le decor est « sans ») : grisee,
      // conservee dans la liste pour que la numerotation ne bouge pas
      var vide = !!emptyExtra[n];
      st.classList.toggle('is-empty', vide);
      var edit = st.querySelector('[data-cfg2-edit]');
      if (edit) {
        if (active || vide) { edit.setAttribute('hidden', ''); }
        else { edit.removeAttribute('hidden'); edit.textContent = done ? (I18N.edit || 'Edit') : (I18N.choose || 'Choose'); }
      }
      var sum = st.querySelector('[data-cfg2-summary]');
      if (sum) {
        var text = '';
        var skind = st.getAttribute('data-cfg2-kind');
        if (skind === 'word') text = word ? '« ' + word + ' »' : (visited[n] && !active ? (I18N.none || 'None') : '');
        else if (skind === 'saucer') text = saucer ? saucer.title : (visited[n] && !active ? (SAUCERS && SAUCERS.i18n.none) : '');
        else if (skind === 'pieces') {
          var sp = selectedPieces();
          text = sp.length ? sp.map(pieceLabel).join(' + ') : '';
        }
        else if (skind === 'companions') {
          text = compSel.length
            ? compSel.map(function (c) { return c.label; }).join(' + ')
            : (visited[n] && !active ? (I18N.compAlone || '') : '');
        }
        else if (skind === 'extra') text = extraSummary(st);
        else text = summaryFor(+st.getAttribute('data-cfg2-pos'), combo);
        if (vide && !text) text = I18N.none || 'None';
        if ((!active || vide) && text) { sum.textContent = text; sum.removeAttribute('hidden'); }
        else { sum.setAttribute('hidden', ''); }
      }
      var bar = root.querySelector('[data-cfg2-bar="' + n + '"]');
      if (bar) bar.classList.toggle('is-on', !!visited[n]);
    });

    // rails : re-mesurer quand une etape s'ouvre. Une etape repliee est en display:none,
    // donc ses rangees mesurent 0 : les fleches seraient masquees a tort au retour sur
    // l'etape (ou apres un redimensionnement fait pendant qu'elle etait fermee).
    if (rails.length) {
      rails.forEach(function (r) {
        if (r.clientWidth) syncRail(r);
      });
      var selNow = root.querySelector('.cfg2-step.is-active [data-cfg2-rail] .cfg2-card[aria-pressed="true"]');
      if (selNow) revealInRail(selNow);
    }

    // vignettes d'option contextuelles : la serie suit la valeur d'ancrage choisie
    // (ex les 4 cartes de decor montrent le modele selectionne, pas un modele fige)
    var aIdx = anchorIndex();
    optSteps.forEach(function (st) {
      var raw = st.getAttribute('data-cfg2-optimg-map');
      if (!raw) return;
      var map; try { map = JSON.parse(raw); } catch (e) { return; }
      var serie = map[String(aIdx)] || map['0'];
      if (!serie) return;
      cardsOf(+st.getAttribute('data-cfg2-pos')).forEach(function (card, i) {
        var u = serie[i];
        var im = card.querySelector('img[data-cfg2-fixed-img]');
        if (!u || !im) return;
        u = u + (u.indexOf('?') >= 0 ? '&' : '?') + 'width=240';
        if (im.getAttribute('src') !== u) im.src = u;
      });
    });

    // cartes : dispo + images contextuelles + deltas taille
    optSteps.forEach(function (st) {
      var pos = +st.getAttribute('data-cfg2-pos');
      var prefix = combo.slice(0, pos - 1);
      cardsOf(pos).forEach(function (card) {
        var usable = cardUsable(card, prefix);
        card.classList.toggle('is-off', !usable);
        card.setAttribute('aria-disabled', usable ? 'false' : 'true');
        var note = card.querySelector('[data-cfg2-off-note]');
        if (note) {
          if (!usable && anchorPos) { note.textContent = (I18N.notIn || 'not in {v}').replace('{v}', combo[anchorPos - 1] || ''); note.removeAttribute('hidden'); }
          else { note.setAttribute('hidden', ''); }
        }
        // image contextuelle (les images fixes data-cfg2-fixed-img, ex mug nu des cartes taille, ne sont pas ecrasees)
        var c2 = combo.slice();
        c2[pos - 1] = usable ? effective(card, prefix).val : card.getAttribute('data-cfg2-val');
        var u = imgFor(c2, pos);
        var im = card.querySelector('img:not([data-cfg2-fixed-img])');
        if (u && im && im.getAttribute('src') !== u) im.src = u;
        // delta prix (cartes taille) : combo resolu autour de la valeur de la carte
        var deltaEl = card.querySelector('[data-cfg2-delta]');
        if (deltaEl && base != null) {
          var ov = {}; ov[pos] = card;
          var p = PRICE[comboWithOverride(ov).join('|')];
          if (p != null) {
            var d = p - base;
            // un modele MOINS cher que la reference affichait « prix de base » comme
            // celle-ci (les assiettes a dessert par rapport a l'assiette de presentation) :
            // on montre l'ecart reel, « prix de base » n'est garde que pour un ecart nul
            deltaEl.textContent = d === 0 ? (I18N.basePrice || 'base price') : fmtDelta(d);
            deltaEl.removeAttribute('hidden');
          }
        }
      });
    });

    // deltas des tabs design (vs design de base, au contexte courant)
    if (designStep && total != null) {
      var baseDesignCard = cardsOf(designPos)[0];
      if (baseDesignCard) {
        var cBase = combo.slice();
        cBase[designPos - 1] = baseDesignCard.getAttribute('data-cfg2-val');
        var pBase = PRICE[cBase.join('|')];
        [].forEach.call(designStep.querySelectorAll('[data-cfg2-tab-delta]'), function (el) {
          var gi = el.getAttribute('data-cfg2-tab-delta');
          var first = designStep.querySelector('.cfg2-card[data-cfg2-gi="' + gi + '"]');
          if (!first || pBase == null) { el.setAttribute('hidden', ''); return; }
          var cg = combo.slice();
          cg[designPos - 1] = first.getAttribute('data-cfg2-val');
          var pg = PRICE[cg.join('|')];
          if (pg != null && pg - pBase > 0) { el.textContent = fmtDelta(pg - pBase); el.removeAttribute('hidden'); }
          else { el.setAttribute('hidden', ''); }
        });
      }
    }

    // recap : image, lignes, prix
    var recapImg = root.querySelector('[data-cfg2-recap-img]');
    if (recapImg) {
      var u = imgFor(combo);
      if (u) { var big = imgAt(u, 720); if (recapImg.getAttribute('src') !== big) recapImg.src = big; }
    }
    optSteps.forEach(function (st) {
      var pos = +st.getAttribute('data-cfg2-pos');
      var el = root.querySelector('[data-cfg2-recap-val="' + pos + '"]');
      if (!el) return;
      if (MULTI && pos === anchorPos) {
        // une ligne « Modele » qui enumere les pieces du service
        var bits = selectedPieces().map(function (p) {
          var cd = cardForPiece(p);
          return pieceLabel(p) + ' ' + familyOf(cd ? cd.getAttribute('data-cfg2-val') : '');
        });
        el.textContent = bits.join(' · ');
      } else el.textContent = summaryFor(pos, combo);
    });
    var wEl = root.querySelector('[data-cfg2-recap-val="word"]');
    if (wEl) wEl.textContent = word ? '« ' + word + ' »' : '-';
    var scEl = root.querySelector('[data-cfg2-recap-val="saucer"]');
    if (scEl) scEl.textContent = saucer ? saucer.title : (SAUCERS ? SAUCERS.i18n.none : '-');

    var priceBox = root.querySelector('[data-cfg2-price]');
    if (MULTI && priceBox && total != null) {
      // un service se lit piece par piece, pas en prix de base + suppléments
      var mp = mainPiece();
      var htmlM = '<div class="c2-line"><span>' + escHtml(pieceLabel(mp) + ' ' + familyOf(combo[anchorPos - 1] || '')) + '</span><span>' + fmtMoney(total) + '</span></div>';
      compSel.forEach(function (c) {
        htmlM += '<div class="c2-line"><span>' + escHtml(c.label + ' ' + c.model) + '</span><span>' + fmtMoney(c.price) + '</span></div>';
      });
      htmlM += '<div class="c2-total"><span>' + (I18N.total || 'Total') + '</span><span>' + fmtMoney(grandTotal) + '</span></div>';
      priceBox.innerHTML = htmlM;
    } else if (priceBox && total != null && priceAtStep(combo, 0) != null) {
      // cascade : piece la moins chere, puis un ecart par etape (cf. priceAtStep)
      var running = priceAtStep(combo, 0);
      var html = '<div class="c2-line"><span>' + (I18N.baseLabel || 'Base price') + '</span><span>' + fmtMoney(running) + '</span></div>';
      var ordered = optSteps.slice().sort(function (a, b) {
        return (+a.getAttribute('data-cfg2-pos')) - (+b.getAttribute('data-cfg2-pos'));
      });
      ordered.forEach(function (stp) {
        var oPos = +stp.getAttribute('data-cfg2-pos');
        var p = priceAtStep(combo, oPos);
        if (p == null) return;
        var d = p - running;
        running = p;
        if (d === 0) return;
        // libelle = nom de l'option d'ancrage (« Taille » sur les mugs, « Modele » sur
        // les assiettes) devant la valeur ; la valeur seule pour les autres options
        var lab = labelOf(oPos, combo[oPos - 1] || '');
        if (oPos === anchorPos) lab = (DIMS.name || I18N.sizeWord || 'Size') + ' ' + lab;
        html += '<div class="c2-line"><span>' + escHtml(lab) + '</span><span>' + fmtDelta(d) + '</span></div>';
      });
      if (saucer) html += '<div class="c2-line"><span>' + escHtml(saucer.title) + '</span><span>' + fmtDelta(saucer.price) + '</span></div>';
      compSel.forEach(function (c) {
        html += '<div class="c2-line"><span>' + escHtml(c.label + ' ' + c.model) + '</span><span>' + fmtDelta(c.price) + '</span></div>';
      });
      html += '<div class="c2-total"><span>' + (I18N.total || 'Total') + '</span><span>' + fmtMoney(grandTotal) + '</span></div>';
      priceBox.innerHTML = html;
    }

    // input id du formulaire : mis a jour directement (ne pas dependre du re-render natif)
    if (variant) {
      [].forEach.call(document.querySelectorAll('form[is="product-form"] input[name="id"]'), function (inp) {
        inp.value = variant.id;
        inp.disabled = false;
      });
    }

    // CTA + barres mobiles (prix = piece + soucoupe eventuelle)
    if (total != null) {
      [].forEach.call(document.querySelectorAll('[data-cfg2-cta-price]'), function (el) { el.textContent = fmtMoney(grandTotal); });
      var mpP = root.querySelector('[data-cfg2-mp-price]');
      if (mpP) mpP.textContent = fmtMoney(grandTotal);
    }
    // « Commander les 3 pieces » quand le service est complete ; libelle d'origine sinon
    if (compSel.length) {
      var nPieces = compSel.length + 1;
      [].forEach.call(document.querySelectorAll('[data-cfg2-cta-label]'), function (el) {
        if (!el.getAttribute('data-cfg2-cta-base')) el.setAttribute('data-cfg2-cta-base', el.textContent.trim());
        el.textContent = (I18N.ctaPieces || 'Order the {n} pieces').replace('{n}', String(nPieces));
      });
    } else {
      [].forEach.call(document.querySelectorAll('[data-cfg2-cta-label][data-cfg2-cta-base]'), function (el) {
        el.textContent = el.getAttribute('data-cfg2-cta-base');
      });
    }
    // motif obligatoire : categorie de design ouverte sans motif concret, OU monogramme sans lettre
    // -> on desactive la commande + on invite a choisir
    var dPending = designPending();
    var mPending = monoActive(combo) && !currentLetter();
    if (dPending && designStep) showNotice(designStep, I18N.pickDesign || 'Choisissez un motif.');
    else if (mPending && designStep) showNotice(designStep, I18N.pickLetter || 'Choisissez une lettre.');
    // etapes extra : recap, overlays, validation texte (no-op sans etape extra)
    var xPending = updateExtras();
    var canBuy = !!variant && variant.av !== false && !dPending && !mPending && !xPending;
    [].forEach.call(document.querySelectorAll('.cfg2-cta'), function (b) { b.disabled = !canBuy; });
    // Dire A COTE DU BOUTON pourquoi il est desactive, et permettre d'y aller d'un clic :
    // sinon la notice reste enfermee dans une etape refermee et le bouton parait mort.
    var pend = root.querySelector('[data-cfg2-pending]');
    if (pend) {
      var raison = '', cible = 0;
      if (!canBuy) {
        if (xPending) { raison = xPending.msg || (I18N.pickDesign || ''); cible = xPending.step; }
        else if (dPending) { raison = I18N.pickDesign || ''; cible = designStep ? +designStep.getAttribute('data-cfg2-step') : 0; }
        else if (mPending) { raison = I18N.pickLetter || ''; cible = designStep ? +designStep.getAttribute('data-cfg2-step') : 0; }
      }
      if (raison) {
        pend.textContent = raison;
        pend.setAttribute('data-cfg2-pending-step', String(cible));
        pend.removeAttribute('hidden');
      } else pend.setAttribute('hidden', '');
    }
    var mp1 = root.querySelector('[data-cfg2-mp-line1]');
    if (mp1) {
      var bits = [];
      if (anchorPos) bits.push(labelOf(anchorPos, combo[anchorPos - 1]));
      if (designPos) bits.push(labelOf(designPos, combo[designPos - 1]));
      mp1.textContent = bits.filter(Boolean).join(' · ');
    }
    var mp2 = root.querySelector('[data-cfg2-mp-line2]');
    if (mp2) {
      var rest = [];
      optSteps.forEach(function (st) {
        var pos = +st.getAttribute('data-cfg2-pos');
        if (pos !== anchorPos && pos !== designPos) rest.push(labelOf(pos, combo[pos - 1]));
      });
      extraSteps.forEach(function (st) { rest.push(extraSummary(st)); });
      if (word) rest.push('« ' + word + ' »');
      mp2.textContent = rest.filter(Boolean).join(' · ');
    }
    var mpImg = root.querySelector('[data-cfg2-mp-img]');
    if (mpImg) { var mu = imgFor(combo); if (mu) mpImg.src = imgAt(mu, 160); }

    updateMono(combo);
    renderStack(compSel);
    updateCommonNotes();
  }

  /* ---------------------------------------------------------- rails
     Familles de l'option d'ancrage rendues en rangees horizontales : fleches affichees
     seulement s'il y a de quoi defiler, desactivees en bout de course, et la valeur
     selectionnee est ramenee dans le champ de vision a l'ouverture de l'etape.        */
  rails = [].slice.call(root.querySelectorAll('[data-cfg2-rail]'));
  function railStep(rail) {
    var card = rail.querySelector('.cfg2-card');
    var w = card ? card.getBoundingClientRect().width + 10 : 158;
    return Math.max(w, Math.floor(rail.clientWidth * 0.8 / w) * w) || w;
  }
  function syncRail(rail) {
    var fam = rail.closest('.cfg2-family');
    var nav = fam ? fam.querySelector('[data-cfg2-rail-nav]') : null;
    var scrollable = rail.scrollWidth - rail.clientWidth > 4;
    if (nav) {
      if (scrollable) nav.removeAttribute('hidden');
      else nav.setAttribute('hidden', '');
      var prev = nav.querySelector('[data-cfg2-rail-prev]');
      var next = nav.querySelector('[data-cfg2-rail-next]');
      if (prev) prev.disabled = rail.scrollLeft <= 2;
      if (next) next.disabled = rail.scrollLeft >= rail.scrollWidth - rail.clientWidth - 2;
    }
  }
  // amene la carte choisie dans le champ de vision, SANS toucher au scroll de la page.
  // Position mesuree par rectangles et non par offsetLeft : la rangee n'est pas positionnee,
  // donc offsetParent est une section lointaine et offsetLeft decalerait le centrage
  // (mesure en QA : 635 au lieu de 474, soit 161px d'ecart).
  function revealInRail(card) {
    var rail = card && card.closest('[data-cfg2-rail]');
    if (!rail || !rail.clientWidth) return;
    var cr = card.getBoundingClientRect(), rr = rail.getBoundingClientRect();
    var pos = cr.left - rr.left + rail.scrollLeft;
    var left = pos - (rail.clientWidth - cr.width) / 2;
    var max = rail.scrollWidth - rail.clientWidth;
    rail.scrollLeft = Math.max(0, Math.min(left, max));
  }
  rails.forEach(function (rail) {
    var fam = rail.closest('.cfg2-family');
    var nav = fam ? fam.querySelector('[data-cfg2-rail-nav]') : null;
    if (nav) {
      var p = nav.querySelector('[data-cfg2-rail-prev]');
      var nx = nav.querySelector('[data-cfg2-rail-next]');
      if (p) p.addEventListener('click', function () { rail.scrollLeft -= railStep(rail); });
      if (nx) nx.addEventListener('click', function () { rail.scrollLeft += railStep(rail); });
    }
    rail.addEventListener('scroll', function () { syncRail(rail); });
    syncRail(rail);
  });
  if (rails.length) {
    window.addEventListener('resize', function () { rails.forEach(syncRail); });
    // la valeur deja selectionnee (ou celle du 1er rail) est visible d'entree
    var selRail = root.querySelector('[data-cfg2-rail] .cfg2-card[aria-pressed="true"]');
    if (selRail) revealInRail(selRail);
  }

  /* ------------------------------------------------------ interactions */
  // cartes
  optSteps.forEach(function (st) {
    var pos = +st.getAttribute('data-cfg2-pos');
    cardsOf(pos).forEach(function (card) {
      card.addEventListener('click', function () {
        if (card.classList.contains('is-off')) return;
        revealInRail(card);
        var already = card.getAttribute('aria-pressed') === 'true';
        if (MULTI && pos === anchorPos) {
          // mode multi : on ne deselectionne QUE dans la plage de la meme piece,
          // les autres pieces gardent leur propre modele
          var pc = pieceOfCard(card);
          var all = cardsOf(pos);
          for (var i = 0; pc && i < all.length; i++) {
            var pi = pieceAt(i);
            if (pi && pi.key === pc.key) all[i].setAttribute('aria-pressed', all[i] === card ? 'true' : 'false');
          }
        } else {
          cardsOf(pos).forEach(function (c) { c.setAttribute('aria-pressed', c === card ? 'true' : 'false'); });
        }
        clearNotices();
        resolveFrom(pos);
        syncNativePicker();
        if (!already) showLoader();
        render();
        // le monogramme ouvre le choix de la lettre : on NE quitte PAS l'etape (avance apres le choix de lettre)
        var isMono = MONO && card.getAttribute('data-cfg2-val') === MONO.value;
        if (!already && !isMono) autoAdvance(+st.getAttribute('data-cfg2-step'));
      });
    });
  });
  // etape « vos assiettes » : cases a cocher, au moins une piece
  var piecesStep = steps.filter(function (s) { return s.getAttribute('data-cfg2-kind') === 'pieces'; })[0] || null;
  if (piecesStep) {
    var pCards = [].slice.call(piecesStep.querySelectorAll('[data-cfg2-piece]'));
    pCards.forEach(function (c) { pieceOn[c.getAttribute('data-cfg2-piece')] = c.getAttribute('aria-pressed') === 'true'; });
    pCards.forEach(function (card) {
      card.addEventListener('click', function () {
        var k = card.getAttribute('data-cfg2-piece');
        var min = (MULTI && +MULTI.min) || 1;
        if (pieceOn[k] && selectedPieces().length <= min) {
          // on ne peut pas vider le service : on le dit au lieu de l'ignorer
          showNotice(piecesStep, I18N.keepOne || '');
          return;
        }
        showNotice(piecesStep, null);
        pieceOn[k] = !pieceOn[k];
        card.setAttribute('aria-pressed', pieceOn[k] ? 'true' : 'false');
        // la piece principale a pu changer : la variante native doit suivre
        syncNativePicker();
        render();
      });
    });
  }

  // tabs design
  if (designStep) {
    [].forEach.call(designStep.querySelectorAll('[data-cfg2-tab]'), function (tab) {
      tab.addEventListener('click', function () {
        var gi = tab.getAttribute('data-cfg2-tab');
        [].forEach.call(designStep.querySelectorAll('[data-cfg2-tab]'), function (t) { t.setAttribute('aria-pressed', t === tab ? 'true' : 'false'); });
        [].forEach.call(designStep.querySelectorAll('[data-cfg2-group]'), function (g) {
          if (g.getAttribute('data-cfg2-group') === gi) g.removeAttribute('hidden');
          else g.setAttribute('hidden', '');
        });
        // onglet Monogramme : selectionne directement le design monogramme -> les lettres s'affichent
        if (tab.hasAttribute('data-cfg2-mono-tab')) {
          var mc = designStep.querySelector('.cfg2-card--mono-hidden');
          if (mc && mc.getAttribute('aria-pressed') !== 'true') mc.click();
        }
        // onglet None : pas de miniature affichee -> selectionne directement la valeur "sans design"
        if (tab.hasAttribute('data-cfg2-none-tab')) {
          var nc = designStep.querySelector('.cfg2-grid--design[data-cfg2-group="0"] .cfg2-card--design');
          if (nc && nc.getAttribute('aria-pressed') !== 'true') nc.click();
        }
        // recalcul (motif obligatoire) : categorie ouverte sans motif -> CTA desactive + invite
        render();
      });
    });
  }
  // en-tetes / edit / recap goto
  steps.forEach(function (st, i) {
    var n = i + 1;
    var head = st.querySelector('.cfg2-step__head');
    if (head) head.addEventListener('click', function (e) {
      if (emptyExtra[n]) return;   // rien a choisir : l'etape ne s'ouvre pas
      if (e.target.closest('[data-cfg2-edit]') || stepNow !== n) goTo(n);
    });
  });
  [].forEach.call(root.querySelectorAll('[data-cfg2-goto]'), function (b) {
    b.addEventListener('click', function () { goTo(+b.getAttribute('data-cfg2-goto'), true); });
  });
  var pendBtn = root.querySelector('[data-cfg2-pending]');
  if (pendBtn) pendBtn.addEventListener('click', function () {
    var n = +pendBtn.getAttribute('data-cfg2-pending-step');
    if (n) goTo(n, true);
  });

  // mode confirm : c'est ce bouton qui fait passer a l'etape suivante
  [].forEach.call(root.querySelectorAll('[data-cfg2-next]'), function (b) {
    b.addEventListener('click', function () {
      var st = b.closest('.cfg2-step');
      if (st) advance(+st.getAttribute('data-cfg2-step'));
    });
  });
  // mot grave
  var wordInput = root.querySelector('[data-cfg2-word]');
  if (wordInput) {
    var wordMax = +wordInput.getAttribute('maxlength') || 18;
    wordInput.addEventListener('input', function () {
      // maxlength ne borne que la SAISIE : on tronque aussi la valeur, sinon un texte trop
      // long arrive quand meme dans la property (colle, autofill, script)
      if (wordInput.value.length > wordMax) wordInput.value = wordInput.value.slice(0, wordMax);
      word = wordInput.value;
      render();
    });
    // NE PAS poser ce garde-fou sur le noeud du formulaire : <product-rerender> le remplace
    // a chaque changement de variante et le listener serait perdu. Voir le listener delegue
    // ci-dessous, qui neutralise toute property vide quel que soit le chemin de soumission.
    // « Valider » / « Sans gravure » = les boutons Continuer de cette etape. Ils ne fermaient
    // que l'accordeon (goTo(0)) : juste tant que le mot est la derniere etape, faux des qu'une
    // etape suit (soucoupe, compagnons). On passe donc a l'etape suivante quand il y en a une.
    var wordStep = root.querySelector('.cfg2-step[data-cfg2-kind="word"]');
    var wordN = wordStep ? +wordStep.getAttribute('data-cfg2-step') : 0;
    function leaveWord() { goTo(wordN && wordN < STEP_COUNT ? nextStepAfter(wordN) : 0); }
    var noneBtn = root.querySelector('[data-cfg2-word-none]');
    if (noneBtn) noneBtn.addEventListener('click', function () { wordInput.value = ''; word = ''; leaveWord(); });
    var doneBtn = root.querySelector('[data-cfg2-word-done]');
    if (doneBtn) doneBtn.addEventListener('click', function () { leaveWord(); });
  }
  // recap image : cacher le loader quand l'image charge
  var recapImgEl = root.querySelector('[data-cfg2-recap-img]');
  if (recapImgEl) recapImgEl.addEventListener('load', hideLoader);

  // AJOUT GROUPE : des qu'une piece secondaire est choisie (soucoupe assortie du mug,
  // ou autres formats du service d'assiettes), on intercepte la soumission native en
  // capture et on pousse toutes les lignes d'un coup via /cart/add.js -> /cart.
  // Chaque ligne porte ses properties ; les compagnons heritent de celles de la piece
  // principale (motif, mot grave), puisque c'est le meme decor.
  // Ecoute DELEGUEE au document, en capture : <product-rerender> REMPLACE le <form>
  // a chaque changement de variante, donc un listener pose sur le noeud form est
  // perdu des le premier clic sur une carte. Le filtre ci-dessous ne retient que le
  // formulaire d'achat de CE configurateur.
  if ((SAUCERS && saucerStep) || (COMPS && compStep) || MULTI) {
    {
      document.addEventListener('submit', function (e) {
        var buyForm = e.target;
        if (!buyForm || buyForm.getAttribute('is') !== 'product-form') return;
        if (!root.contains(buyForm)) return;
        var extraItems = extraPieces();
        if (!saucer && !extraItems.length) return; // piece seule : comportement natif inchange
        e.preventDefault();
        e.stopPropagation();
        var idInp = buyForm.querySelector('input[name="id"]');
        if (!idInp || !idInp.value) { return; }
        var props = {};
        // buyForm.elements inclut les champs rattaches via l'attribut form=
        // (mot grave, monogramme, etapes extra) qui vivent hors du <form>
        [].forEach.call(buyForm.elements, function (inp) {
          if (!inp.name || inp.name.indexOf('properties[') !== 0) return;
          if (inp.disabled) return;
          if (inp.type === 'checkbox' && !inp.checked) return;
          var v = (inp.value == null ? '' : String(inp.value)).trim();
          if (v === '') return;
          var m = inp.name.match(/properties\[(.+)\]/);
          if (m) props[m[1]] = inp.value;
        });
        var hasProps = Object.keys(props).length > 0;
        var main = { id: idInp.value, quantity: 1 };
        if (hasProps) main.properties = props;
        var items = [main];
        if (saucer) items.push({ id: saucer.id, quantity: 1 });
        extraItems.forEach(function (c) {
          var line = { id: c.id, quantity: 1 };
          if (hasProps) line.properties = props;
          items.push(line);
        });
        // Jeton commun aux lignes d'un meme envoi : sans lui, rien ne dit a l'atelier que
        // ces assiettes forment UN service (ni que cette soucoupe va avec ce mug). Une
        // property prefixee par « _ » est masquee au client mais visible dans l'admin et
        // l'API. Meme convention que le nœud-nœud (`_nn_set`).
        if (items.length > 1) {
          var token = 'plate-' + idInp.value + '-' + Date.now();
          items.forEach(function (it) {
            it.properties = it.properties || {};
            it.properties._service = token;
          });
        }
        // Shopify affiche les lignes d'un meme ajout de la plus recente a la plus ancienne :
        // on inverse pour que le service se lise de la plus grande piece a la plus petite.
        items.reverse();
        var rootUrl = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
        fetch(rootUrl + 'cart/add.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: items })
        }).then(function (r) {
          if (!r.ok) throw new Error('add failed');
          window.location.href = rootUrl + 'cart';
        }).catch(function () {
          // repli : on retombe sur la commande de la seule piece principale
          saucer = null; comp = {}; buyForm.submit();
        });
      }, true);
    }
  }


  // Toute property vide doit etre neutralisee AVANT l'envoi, sinon la commande porte des
  // lignes comme « Mot gravé : » vides. Ecoute DELEGUEE en capture : elle survit au
  // remplacement du formulaire par <product-rerender>, et couvre aussi bien la soumission
  // native (une seule piece) que l'ajout groupe.
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || f.getAttribute('is') !== 'product-form' || !root.contains(f)) return;
    // Le champ du mot grave est pilote ICI, dans LES DEUX SENS : desactive s'il est vide,
    // REACTIVE s'il porte un mot. Sans la reactivation, un premier envoi sans mot le
    // laissait desactive et le mot d'un envoi suivant partait a la poubelle en silence.
    var w = root.querySelector('[data-cfg2-word]');
    if (w) w.disabled = String(w.value == null ? '' : w.value).trim() === '';
    // Les autres properties ont chacune leur gestionnaire (etapes extra, monogramme) qui
    // decide de les activer : ici on se contente de neutraliser celles qui sont vides,
    // jamais de les reactiver, pour ne pas ressusciter une valeur perimee.
    [].forEach.call(f.elements, function (inp) {
      if (!inp.name || inp.name.indexOf('properties[') !== 0 || inp === w) return;
      if (String(inp.value == null ? '' : inp.value).trim() === '') inp.disabled = true;
    });
  }, true);

  /* ------------------------------------------------------------- boot */
  // tab design actif = groupe du design selectionne
  if (designStep) {
    var selDesign = selCard(designPos);
    if (selDesign) {
      var gi = selDesign.getAttribute('data-cfg2-gi') || '0';
      [].forEach.call(designStep.querySelectorAll('[data-cfg2-tab]'), function (t) { t.setAttribute('aria-pressed', t.getAttribute('data-cfg2-tab') === gi ? 'true' : 'false'); });
      [].forEach.call(designStep.querySelectorAll('[data-cfg2-group]'), function (g) {
        if (g.getAttribute('data-cfg2-group') === gi) g.removeAttribute('hidden');
        else g.setAttribute('hidden', '');
      });
    }
  }
  syncNativePicker();
  render();

  /* --- fonte du texte peint : re-fit quand elle est reellement chargee ------
     Le fit-to-box mesure le texte avec getComputedTextLength(). Tant que la
     fonte CarronPersonalization (CDN) n'est pas chargee, la mesure porte sur la
     police de REPLI, plus etroite : le moteur en deduit une taille trop grande
     et les lettres debordent de la piece (constate sur le monogramme, 64 unites
     de large pour une box de 51). On force donc le chargement, puis on refait le
     rendu avec la vraie mesure. Reprise du custom_liquid APO d'origine, qui
     faisait exactement ce fonts.load().then(re-fit).                         */
  if (document.fonts && document.fonts.load) {
    try {
      document.fonts.load('16px "CarronPersonalization"').then(function () { render(); }, function () {});
    } catch (e) { /* navigateur sans Font Loading API : mesure de repli, sans re-fit */ }
  }
})();
